// extracted by mini-css-extract-plugin
export default {"wrapper":"Beginner_wrapper__0gfS2","selectCurrency":"Beginner_selectCurrency__lnnMu"};